// extracted by mini-css-extract-plugin
module.exports = {"eventClosedHero":"eventClosedHero_eventClosedHero__tTObq"};